import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import Work from './pages/Work';
import YouTubeEdits from './pages/YouTubeEdits';
import Reels from './pages/Reels';
import Feedback from './pages/Feedback';
import Contact from './pages/Contact';
import Preset from './pages/Preset';
function App() {
  return (
    <Router>
      <AnimatePresence mode="wait">
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="work" element={<Work />} />
            <Route path="youtube-edits" element={<YouTubeEdits />} />
            <Route path="reels" element={<Reels />} />
            <Route path="feedback" element={<Feedback />} />
            <Route path="contact" element={<Contact />} />
            <Route path="preset" element={<Preset />} />
          </Route>
        </Routes>
      </AnimatePresence>
    </Router>
  );
}

export default App;
